export const CAROUSEL_COUPONS_LIMIT = 15
